// extracted by mini-css-extract-plugin
export default {"tooltip":"Go-z","sharingV2":"Ho-z","sharingIconsV2":"Io-z","links":"Jo-z","link":"Ko-z","facebookV2":"Lo-z","twitterV2":"Mo-z","pinterestV2":"No-z"};